import React from 'react';
import { colour } from '../../styles/GlobalStyles';

// Filled front-on bus — matches the filled style of Car.js/House.js. Used as the mode
// token on a bus stop row in the co-living Transit section. Sized via the `size` prop
// (defaults to 16 to match the other icons); colour via `fill`.
//
// `knockout` is the colour of the windows/lights punched out of the body — it must match
// whatever sits behind the icon, so it defaults to the analysis card's own background.
function Bus(props) {
    const fill = props.fill;
    const knockout = props.knockout || colour.gray01;
    const className = props.className;
    const size = props.size || 16;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            {/* body */}
            <rect x="4" y="3" width="16" height="15" rx="3" fill={fill} />
            {/* windscreen — knocked out of the body so the shape reads as a bus at 16px */}
            <rect x="6.5" y="6" width="11" height="5" rx="1" fill={knockout} />
            {/* headlights */}
            <circle cx="7.5" cy="14.5" r="1.2" fill={knockout} />
            <circle cx="16.5" cy="14.5" r="1.2" fill={knockout} />
            {/* wheels */}
            <rect x="5" y="18" width="3.5" height="3" rx="1.2" fill={fill} />
            <rect x="15.5" y="18" width="3.5" height="3" rx="1.2" fill={fill} />
        </svg>
    );
}

export default Bus;
